<router-outlet> </router-outlet>
<p-toast />
<p-confirmDialog
  [style]="{ 'max-width': '400px' }"
  [baseZIndex]="10000"
></p-confirmDialog>
